module.exports = __webpack_public_path__ + "media/bootstrap-icons/pen-a8952e2c.svg";